module.exports = __webpack_public_path__ + "img/sw3-b4.f09bba68.jpg";